/* eslint-disable */
import {Pressable, StyleSheet, Text, View} from 'react-native';
import {card, colors, radii, spacing} from '../../config/theme';

// A tappable card with a selected state.
// indicator="radio": circle on the right, vertically centred (list rows, screen 2)
// indicator="check": small check badge on the top-right corner (grid tiles, screen 3)
const SelectCard = ({
  selected,
  onPress,
  indicator = 'radio',
  style,
  children,
}) => (
  <Pressable
    onPress={onPress}
    style={[styles.card, selected && styles.cardSelected, style]}>
    {children}

    {indicator === 'radio' && (
      <View
        style={[
          styles.radio,
          indicator === 'radio' && styles.radioPos,
          selected && styles.radioOn,
        ]}>
        {selected && <Text style={styles.checkMark}>✓</Text>}
      </View>
    )}

    {indicator === 'check' && selected && (
      <View style={[styles.radio, styles.checkPos, styles.radioOn]}>
        <Text style={styles.checkMark}>✓</Text>
      </View>
    )}
  </Pressable>
);

const styles = StyleSheet.create({
  card: {
    ...card,
    padding: spacing.md + 4,
    borderWidth: 1.5,
    borderColor: colors.borderSubtle,
  },
  cardSelected: {
    backgroundColor: colors.mintTint,
    borderColor: colors.secondary,
  },
  radio: {
    width: 24,
    height: 24,
    borderRadius: radii.pill,
    borderWidth: 1.5,
    borderColor: colors.border,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioPos: {
    position: 'absolute',
    right: spacing.md + 4,
    top: '50%',
    marginTop: -12,
  },
  checkPos: {
    position: 'absolute',
    top: -8,
    right: -8,
  },
  radioOn: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  checkMark: {fontSize: 13, color: colors.onPrimary},
});

export default SelectCard;